import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Form submitted:', formData);
    // Reset form
    setFormData({
      name: '',
      email: '',
      subject: '',
      message: ''
    });
  };

  const faqs = [
    {
      question: "How do I start playing?",
      answer: "Just click the 'Play Now' button on any game to get started. No registration required!"
    },
    {
      question: "Are the games free?",
      answer: "Yes! All games are free to play and use virtual coins. No real money is involved."
    },
    {
      question: "How can I earn more coins?",
      answer: "You can earn coins from daily bonuses, achievements, and by participating in tournaments."
    },
    {
      question: "Can I play with my friends?",
      answer: "Yes! You can invite friends and compete with them in tournaments and challenges."
    }
    
  ];
  

  return (
<div className="contact-page">
<div className="container">
  <div className="contact-header">
    <h1>Contact Us</h1>
    <p>Have a question? We're here to help!</p>
  </div>

  <div className="contact-content">
    <div className="contact-form-section">
      <h2>Send Us a Message</h2>
      <form className="contact-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">Name</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            placeholder="Your Name"
          />
        </div>

        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            placeholder="Your Email"
          />
        </div>

        <div className="form-group">
          <label htmlFor="subject">Subject</label>
          <input
            type="text"
            id="subject"
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            required
            placeholder="Subject"
          />
        </div>

        <div className="form-group">
          <label htmlFor="message">Message</label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
            placeholder="Your Message"
            rows="5"
          ></textarea>
        </div>

        <button type="submit" className="button button--primary">
          Send Message
        </button>
      </form>
    </div>

    <div className="contact-info-section">
      <div className="contact-info">
        <h2>Other Ways to Reach Us</h2>
        <div className="contact-info__item">
          <span className="contact-info__icon">📧</span>
          <div className="contact-info__content">
            <h3>Email</h3>
            <p>support@connectplay.site</p>
          </div>
        </div>
        <div className="contact-info__item">
          <span className="contact-info__icon">💬</span>
          <div className="contact-info__content">
            <h3>Live Chat</h3>
            <p>Available 24/7</p>
          </div>
        </div>
      </div>

      <div className="faq-section">
        <h2>Frequently Asked Questions</h2>
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <h3 className="faq-question">{faq.question}</h3>
              <p className="faq-answer">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
</div>

</div>

  );
};

export default Contact; 